import React from "react";

const CreditManagement = () => {
  return <div>Credit Management Page (Admin Only)</div>;
};

export default CreditManagement;
